export const SESSION_EXPIRED_TRANSLATIONS = {
    toast: {
        "pt-BR": "Sua sessão expirou. Faça login novamente.",
        en: "Your session expired. Please log in again.",
        es: "Tu sesión expiró. Inicia sesión de nuevo.",
        de: "Ihre Sitzung ist abgelaufen. Bitte melden Sie sich erneut an.",
    },
} as const;
